<template>
  <ul class="pagination">
    <!--<li class="page-item">-->
      <!--<a :class="['prev-link', {'not-allowed': parseInt(currentPage) === 1}]" href="javascript:void(0);"><</a>-->
    <!--</li>-->
    <li class="page-item" v-for="btn in btnCount">
      <a :class="['page-link', {'active': parseInt(currentPage) === btn}]"
         href="javascript:void(0);"
         @click="changePage(btn)">{{ btn }}</a>
    </li>
    <!--<li class="page-item">-->
      <!--<a :class="['next-link', {'not-allowed': parseInt(currentPage) === btnCount.length}]" href="javascript:void(0);">></a>-->
    <!--</li>-->
  </ul>
</template>

<script>
  'use strict'

  export default {
    name: 'pagination',
    props: {
      count: {
        type: Number,
        defalut: function () {
          return 0
        }
      },
      page: {
        type: Number,
        defalut: function () {
          return 1
        }
      },
      pageSize: {
        type: Number,
        defalut: function () {
          return 10
        }
      },
      btnShow: {
        type: Number,
        defalut: function () {
          return 5
        }
      }
    },
    computed: {
      btnCount () {
        // 총 아이템 수와 페이지당 아이템 수를 나누어 버튼에 총 갯수를 구한다.
        const vm = this
        const count = vm.count
        const pageSize = vm.pageSize

        let btnCount = 0
        if (count > 0) {
          btnCount = Math.ceil(count / pageSize)
        }

        return btnCount
      }
    },
    data: function () {
      return {
        currentPage: 1
      }
    },
    methods: {
      changePage: function (page) {
        const vm = this
        const currentPage = vm.currentPage

        // 선택된 페이지와 현재 페이지가 같지 않을 경우에만 실행
        if (page && parseInt(currentPage) !== page) {
          vm.currentPage = page
          vm.$emit('changePage', page)
        }
      }
    },
    created: function () {
      this.currentPage = this.page
    }
  }
</script>

<style lang="scss" scoped>
 .pagination {
   .page-item {
     a {
       padding: 4px 26px;
       font-size: 12px;
       font-weight: normal;
       font-style: normal;
       font-stretch: normal;
       line-height: 1.67;
       letter-spacing: -0.23px;
       text-align: center;
       border: none;
       border-radius: initial;
       color: $hzc-black;

       @media (max-width: 767px) {
         padding: 4px 16px;
       }
     }

     .page-link {
       &:hover,
       &:focus {
         font-weight: bold;
         background-color: initial;
         border-bottom: 1px solid $hzc-black;
       }
     }

     .prev-link, .next-link {
       &:hover {
         font-weight: bold;
         background-color: initial;
       }

       &:focus {
         background-color: initial;
       }
     }

     .active {
       font-weight: bold;
       background-color: initial;
       border-bottom: 1px solid $hzc-black;
     }

     .not-allowed {
       cursor: not-allowed;
     }
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue